/**
 * @generated SignedSource<<a269ec7befb799c8019e2b15a7acb5a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templateDescriptionRelayFragment$data = {
  readonly aboutThisTemplate: string | null | undefined;
  readonly " $fragmentType": "templateDescriptionRelayFragment";
};
export type templateDescriptionRelayFragment$key = {
  readonly " $data"?: templateDescriptionRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templateDescriptionRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "templateDescriptionRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "aboutThisTemplate",
      "storageKey": null
    }
  ],
  "type": "ContentPlatformTemplate",
  "abstractKey": null
};

(node as any).hash = "aa0e80feaefdced6bd157a52a501e383";

export default node;
